import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DocumentStatus } from '../../../../domain/dictionary.model';
import { OfferAction } from '../../store/offer.action';
import { OfferState } from '../../store/offer.state';
import { RouterAction } from '../../store/router.action';

@Injectable()
export class OfferResolver implements Resolve<any> {

    constructor(private store: Store) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        const id = +route.parent.params.id;
        return this.store.dispatch(new OfferAction.GetOne(id))
            .pipe(tap(() => {
                const status = this.store.selectSnapshot(OfferState.getOffer).status.code;
                if (route.data.statuses.indexOf(status) === -1) {
                    if ([DocumentStatus.OFFER, DocumentStatus.IOFFER, DocumentStatus.CANCELLED].indexOf(status as DocumentStatus) !== -1) {
                        this.store.dispatch(new RouterAction.Navigate(['/calculation', id, 'offer']));
                    } else {
                        this.store.dispatch(new RouterAction.Navigate(['/calculation', id, 'card']));
                    }
                }
            }));
    }
}
